/** @format */

import { TailSpin } from 'react-loading-icons';

const Loading = () => {
	return (
		<div className='bg-dark-mode-3 vh-100'>
			<TailSpin
				className='position-fixed'
				style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}
			/>
			{/*<span
				className='position-fixed text-white f-14'
				style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
				در حال بارگذاری...
	</span>*/}
		</div>
	);
};

export default Loading;
